import MainContentModel, * as allContentModels from './contentmodel';

export const ContentModels = allContentModels;
export const ContentModel = MainContentModel;

import './style.css';

export const description = "This is the example-activity.";
export const instructions = ``;



// WEBPACK FOOTER //
// ./app_modules/collapsible-activity/index.js